/**
 * DIADEM: initialises Owl carousels, including after a combined-listing swap.
 *
 * sections/carousel.liquid used to initialise itself from an inline
 * `DOMContentLoaded` handler. That works once. When the variant picker swaps in
 * a different child product's section, `toReplace.replaceWith(replaceWith)`
 * puts fresh, un-initialised markup on the page — DOMContentLoaded fired long
 * ago, and scripts injected via a DOM swap never execute — so the "in action"
 * slides rendered as a raw unstyled stack with no slider.
 *
 * This file owns initialisation for any carousel carrying `data-owl-config`.
 * The options live on that attribute so there is a single source of truth in
 * the section file.
 *
 * Scope note: this deliberately matches `[data-owl-config]` and not
 * `.owl-carousel`. sections/specs-carousel.liquid runs its own init on
 * `.specs-frame` and must not be touched.
 */
(function () {
  var SELECTOR = '[data-owl-config]';

  function initOne(el) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.owlCarousel) return;
    var $el = window.jQuery(el);

    var config;
    try {
      config = JSON.parse(el.getAttribute('data-owl-config') || '{}');
    } catch (e) {
      return;
    }

    // A swapped-in node is fresh, but guard anyway so a double call can't
    // stack two Owl instances on one element.
    if ($el.hasClass('owl-loaded')) {
      $el.trigger('destroy.owl.carousel');
      $el.removeClass('owl-loaded owl-hidden').addClass('owl-carousel');
    }

    $el.owlCarousel(config);
    watchVisibility(el);
  }

  /* Owl measures its container once, at init. A carousel that starts inside a
     hidden panel (the product-tabs "Technology" tab is display:none on load)
     measures 0px, so every slide is laid out 0px wide and the carousel stays
     collapsed even after the tab is opened. Owl only re-measures on a window
     resize, which never happens here. Watch the element and refresh Owl the
     moment it gains a real width. */
  var observer = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      var width = Math.round(entry.contentRect.width);
      if (width > 0 && width !== el.__diademOwlWidth) {
        var wasHidden = !el.__diademOwlWidth;
        el.__diademOwlWidth = width;
        if (wasHidden) window.jQuery(el).trigger('refresh.owl.carousel');
      } else if (width === 0) {
        el.__diademOwlWidth = 0;
      }
    });
  }) : null;

  function watchVisibility(el) {
    if (!observer || el.__diademOwlWatched) return;
    el.__diademOwlWatched = true;
    el.__diademOwlWidth = Math.round(el.getBoundingClientRect().width);
    observer.observe(el);
  }

  function initWithin(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SELECTOR)) initOne(root);
    root.querySelectorAll(SELECTOR).forEach(initOne);
  }

  function initAll() { initWithin(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* The variant picker announces each node it is about to swap in. The node is
     not in the document yet, so initialise on the next tick, once replaceWith()
     has run and Owl can measure real widths. */
  document.addEventListener('on:variant:before-replace-element', function (evt) {
    var incoming = evt.detail && evt.detail.replaceWith;
    if (!incoming) return;
    var hasCarousel = (incoming.matches && incoming.matches(SELECTOR))
      || (incoming.querySelector && incoming.querySelector(SELECTOR));
    if (!hasCarousel) return;
    setTimeout(function () { initWithin(incoming); }, 0);
  });
})();
